import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): any {
    return this.authService.user$.pipe(
      take(1),
      map(user => {
        if (user?.isPlatformAdmin && this.authService.getPreferredAppMode() !== 'org') {
          this.router.navigate(['/platform-admin']);
          return false;
        }
        if (user && user.role === 'admin') {
          return true;
        } else {
          this.router.navigate(['/admin/history']);
          return false;
        }
      })
    );
  }
}


